import { has, map, pluck, filter, includes, isEmpty } from 'ramda';
import * as LokiDb from './loki-db';
import { selectors } from './selectors';

const spriteErrors = [];

/*
 * If there is a category / logo that is not in the style complain about it.
 * We either need to add the category / logo to the spritesheet or get rid of that category / logo.
 * checkSpritesheetForErrors :: ([String], Object) -> ()
 */
const checkSpritesheetForErrors = (venueSprites, styleSprites) => {
    const checkStyleSprites = venueSprite => {
        const styleHasSprite = has(venueSprite, styleSprites);

        if (!styleHasSprite) {
            spriteErrors.push(
                `The spritesheet does not have the sprite for ${venueSprite}. Is this a valid category? Add the svg to the spritesheet or change the category.`,
            );
        }
    };

    map(checkStyleSprites, venueSprites);
};

/*
 * Get the categories / logos for every feature in the venue and check for errors
 * checkSpritesForVenue :: VenueId -> ()
 */
const checkSpritesForVenue = venueId => {
    const venueSprites = LokiDb.getSpritesForVenue(venueId);
    const styleSprites = selectors.getSprites();

    if (!styleSprites || !venueSprites) return;

    const hasBadgeList = pluck('canonicalName', LokiDb.getHasBadgeList());
    const filteredVenueSprites = filter(category => includes(category, hasBadgeList), venueSprites);

    checkSpritesheetForErrors(filteredVenueSprites, styleSprites);

    // eslint-disable-next-line no-console
    if (!isEmpty(spriteErrors)) console.error(spriteErrors.join('\n'));
};

export { checkSpritesForVenue };
